import { render, staticRenderFns } from "./QuickOddChangeModal.vue?vue&type=template&id=74134235&"
import script from "./QuickOddChangeModal.vue?vue&type=script&lang=js&"
export * from "./QuickOddChangeModal.vue?vue&type=script&lang=js&"
import style0 from "./QuickOddChangeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports